// extracted by css-extract-rspack-plugin
export default {"priceStats":"_8c1b8866","negativeLeftMargin":"_52e1f02c","source":"_a0ec7c77"};